import { CdpaButtonComponent, CdpaButtonId } from "../../common/components/cdpaButton.component";
import { CdpaCheckboxComponent } from "../../common/components/cdpaCheckbox.components";
import { CdpaInputComponent, CdpaInputId } from "../../common/components/cdpaInput.component";
import { attachValidationOnSubmitClick } from "./formHelpers/formHelpers";
import { FormId } from "./common/formId";
import "./login-idp-update-profile.scss";
import "./template.scss";
export class LoginIdpUpdateProfile {
    constructor() {
        this.emailInput = new CdpaInputComponent(CdpaInputId.Email);
        const form = document.getElementById(FormId.IdpUpdateProfile);
        const usernameInput = new CdpaInputComponent(CdpaInputId.RegisterUsername);
        const requiredConsentCheckbox = new CdpaCheckboxComponent("consents");
        // Initialize marketing checkboxes so that they send metrics when toggled
        new CdpaCheckboxComponent("newsletterConsent");
        new CdpaCheckboxComponent("thirdPartyConsent");
        const submitButton = new CdpaButtonComponent(CdpaButtonId.Register);
        attachValidationOnSubmitClick(submitButton, form, [usernameInput, this.emailInput, requiredConsentCheckbox]);
        this.setEmailInputVisibility();
    }
    setEmailInputVisibility() {
        // we hide the input component if it returns prefilled in this form
        // we need to mark it valid for form validation
        // it should be only displayed and editable if we are missing this information from provider
        if (this.emailInput.value) {
            this.emailInput.isHidden = true;
        }
    }
}
